export enum ExtendedPropertyType {
    Text = "text",
    Number = "number",
    Amount = "amount",
    Date = "date",
}

export enum SortCriteriaDirection {
    Asc = "ASC",
    Desc = "DESC",
}

export enum PhoneFormat {
    ApiFormat = "0000000000",
}

export enum PhoneNumberDigits {
    PhoneNumberWithoutCountryCode = 10,
    PhoneNumberWithCountryCode = 11,
}

export enum SizeBytes {
    Bytes = "Bytes",
    KB = "KB",
    MB = "MB",
    GB = "GB",
    TB = "TB",
}

export const DebounceTiming = 500;

export enum TransformToCase {
    Lower,
    Upper,
}

export enum DataType {
    Boolean = "DAT_BOOLEAN",
    Text = "DAT_TEXT",
    Integer = "DAT_INTEGER",
    Number = "DAT_NUMBER",
    Date = "DAT_DATE",
    Datetime = "DAT_DATETIME",
    Decimal = "DAT_DECIMAL",
}

export enum UserIdConversionType {
    Local = "Local",
    External = "External",
}

export enum TableVariant {
    Minimal = "minimal",
    Primary = "primary",
}

export enum AgentType {
    Individual = "PAT_INDIVIDUAL",
    Company = "PAT_COMPANY",
}

export enum PartyType {
    Individual = "PAT_INDIVIDUAL",
    Company = "PAT_COMPANY",
}

export const NIL_UUID = "00000000-0000-0000-0000-000000000000";
